import { useContext } from 'solid-js';
import { AppContext } from '../../../app-context-provider/app-context-provider';
import { Text } from '../../text/text';
import theme from '../../../style/theme';
import { ErrorCatcher } from '../../../tools/error-catcher';

type RadioProps = {
    whenClicked?: (e?: any) => void;
    value: string;
    isChecked: boolean;
    name: string;
    id?: string;
    readableName?: string;
    title?: string;
}

export const Radio = (props: RadioProps, hasErrors = false) => {
    const {viewport} = useContext(AppContext);
    const isMobile = () => viewport.width <= theme.breakpoints.MOBILE;

    const id = () => `radio-${(props.id || props.value || '')}`;

    return (
        <ErrorCatcher componentName='Radio'>
            <label for={id()}
                class={`
                    relative flex items-center cursor-pointer
                    [&>input]:mr-[0.9rem]
                    max-mobile:py-[0.5rem]
                    ${hasErrors ? 'border border-primary' : 'border-none'}
                `}
            >
                <input
                    id={id()}
                    onClick={props.whenClicked}
                    type='radio'
                    value={props.value}
                    name={props.name}
                    title={props.title}
                    class="peer m-0 appearance-none border-1 border-gray-dark bg-clip-content !p-0 cursor-pointer
                        w-[1rem] h-[1rem] rounded-half
                        checked:bg-primary
                        bg-white
                        checked:border-primary
                        max-mobile:border-0"

                />
                <Text
                    noBlockSpacing={true}
                    fontSize={isMobile() ? 'normal' : 'small'}
                    {...props.isChecked && {
                        color: theme.palette.primary
                    }}
                >
                    {props.readableName}
                </Text>
            </label> 
        </ErrorCatcher>
    );
};
